import { Phone, MessageCircle } from "lucide-react";
import { useLang } from "@/context/LanguageContext";
import { SITE } from "@/data/site";

export default function FloatingContact() {
  const { t } = useLang();
  return (
    <div className="fixed bottom-5 right-5 z-40 flex flex-col gap-3">
      <a
        href={SITE.whatsappHref}
        target="_blank"
        rel="noopener noreferrer"
        aria-label={t.floating.whatsapp}
        title={t.floating.whatsapp}
        data-testid="floating-whatsapp-button"
        className="group flex items-center gap-2 rounded-full bg-wa text-white p-4 shadow-card-hover hover:bg-[#1fb855] active:scale-[0.96] transition-all duration-200"
      >
        <MessageCircle className="w-6 h-6" />
        <span className="max-w-0 overflow-hidden whitespace-nowrap text-sm font-semibold group-hover:max-w-[180px] group-hover:ml-1 transition-all duration-300">
          {t.floating.whatsapp}
        </span>
      </a>
      <a
        href={SITE.phoneHref}
        aria-label={t.floating.call}
        title={t.floating.call}
        data-testid="floating-call-button"
        className="group flex items-center gap-2 rounded-full bg-navy text-white p-4 shadow-card-hover hover:bg-royal active:scale-[0.96] transition-all duration-200"
      >
        <Phone className="w-6 h-6 animate-pulse" />
        <span className="max-w-0 overflow-hidden whitespace-nowrap text-sm font-semibold group-hover:max-w-[140px] group-hover:ml-1 transition-all duration-300">
          {t.floating.call}
        </span>
      </a>
    </div>
  );
}
